module.exports = __webpack_public_path__ + "img/[鄙视].bbdec61a.svg";